import { Skeleton } from "@/components/ui/skeleton";

export function FlashcardsSkeleton() {
  return (
    <>
      {/* 즐겨찾기 카드 스켈레톤 */}
      <div className="flex gap-3 px-5">
        <Skeleton className="flex-1 h-[122px] rounded-xl" />
      </div>

      {/* 세트 목록 스켈레톤 */}
      <div className="flex flex-col gap-4 px-5">
        {Array.from({ length: 3 }, (_, i) => (
          <div key={i} className="relative rounded-lg bg-white pt-4 px-5 pb-5 flex flex-col gap-5.5">
            <div className="absolute top-3 right-0 text-xs text-muted-foreground font-medium bg-muted rounded-l w-15 h-6" />
            <Skeleton className="h-6 w-32" />
            <Skeleton className="h-1.5 w-full rounded-full" />
          </div>
        ))}
      </div>
    </>
  );
}
